import React from 'react';
import { formatDateTime } from '../../utils/formatters';

export default function NotificationList({ onClose }) {
  const NotificationContext = require('../../context/NotificationContext').NotificationContext;
  const { notifications, markRead, markAllRead } = React.useContext(NotificationContext);

  return (
    <div style={{
      position: 'absolute', top: '110%', right: 0, width: 320,
      background: 'var(--brand-white)', border: '1px solid var(--gray-200)',
      borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-lg)',
      zIndex: 500, overflow: 'hidden',
    }}>
      <div style={{ padding: '0.875rem 1rem', borderBottom: '1px solid var(--gray-100)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong style={{ fontFamily: 'var(--font-display)', fontSize: '0.95rem' }}>Notifications</strong>
        <button className="btn btn-secondary btn-sm" onClick={markAllRead}>Mark all read</button>
      </div>
      <div style={{ maxHeight: 360, overflowY: 'auto' }}>
        {notifications.length === 0 ? (
          <p style={{ padding: '1.5rem', textAlign: 'center', color: 'var(--gray-400)', fontSize: '0.875rem' }}>No notifications</p>
        ) : notifications.map(n => (
          <div key={n.id} onClick={() => markRead(n.id)} style={{
            padding: '0.875rem 1rem',
            borderBottom: '1px solid var(--gray-50)',
            background: n.is_read ? 'transparent' : 'var(--gray-50)',
            cursor: 'pointer',
            transition: 'background var(--transition)',
          }}>
            <p style={{ margin: '0 0 0.2rem', fontSize: '0.8125rem', fontWeight: n.is_read ? 500 : 700 }}>{n.title || 'Notification'}</p>
            <p style={{ margin: '0 0 0.25rem', fontSize: '0.8125rem', fontWeight: n.is_read ? 400 : 500 }}>{n.message}</p>
            {n.event_code && <p style={{ margin: '0 0 0.25rem', fontSize: '0.72rem', color: 'var(--gray-500)' }}>{n.event_code}</p>}
            <p style={{ margin: 0, fontSize: '0.75rem', color: 'var(--gray-400)' }}>{formatDateTime(n.created_at)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}